import { buildMetricsPalette } from '@/shared/constants/metricsPalette';
import { isMetricThresholdDisabled, type MetricThreshold } from '@/shared/utils/metricsThresholds';

export type ChartGuideLine = { value: number; color: string; label?: string };

export const buildThresholdGuideLines = (threshold: MetricThreshold): ChartGuideLine[] => {
  if (isMetricThresholdDisabled(threshold)) return [];
  const palette = buildMetricsPalette();
  return [
    { value: threshold.warn, color: palette.fail, label: `Warn threshold: ${threshold.warn}` },
    {
      value: threshold.target,
      color: palette.skip,
      label: `Target threshold: ${threshold.target}`,
    },
  ];
};
